import ChrPropTypes from '../../../../utils/ChrPropTypes';
import i18n from '../../../../utils/ChrI18n';
import { handleKeyDown } from '../../../../utils/accessibilityUtils';

const purposeAssessmentFormPropsList = {
  completedAssessment: ChrPropTypes.bool,
  currentQuestionPosition: ChrPropTypes.number,
  totalQuestionsCount: ChrPropTypes.number,
  assessmentDetailsHash: ChrPropTypes.object,
  introductionContainerHash: ChrPropTypes.object,
  saveAnswerUrl: ChrPropTypes.string,
  questionTypeMap: ChrPropTypes.object,
  savePositionUrl: ChrPropTypes.string,
  quickReminderHash: ChrPropTypes.object,
  resultsRenderingRequiredData: ChrPropTypes.object,
  translationOptions: ChrPropTypes.object
}

const cardContainerClass = "cui-rounded-border-card-sm";

const commonErrorText = () => {
  return i18n.t("common_text.error_msg.something_went_wrong");
}

const mdButtonClasses = "btn btn-md btn-rounded";

export {
  purposeAssessmentFormPropsList,
  handleKeyDown,
  cardContainerClass,
  commonErrorText,
  mdButtonClasses
}
